import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ConfigProvider } from './contexts/ConfigContext'
import Layout from './components/Layout'
import Home from './pages/Home'
import Products from './pages/Products'
import Company from './pages/Company'
import Downloads from './pages/Downloads'
import ProductDetail from './pages/ProductDetail'
import ProductPreview from './pages/ProductPreview'
import AdminLogin from './pages/AdminLogin'
import AdminDashboard from './pages/AdminDashboard'
import AdminProducts from './pages/AdminProducts'
import AdminCarousel from './pages/AdminCarousel'
import AdminFiles from './pages/AdminFiles'
import AdminSettings from './pages/AdminSettings'
import AdminCompany from './pages/AdminCompany'

function App() {
  return (
    <ConfigProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:id" element={<ProductDetail />} />
            <Route path="/preview/product" element={<ProductPreview />} />
            <Route path="/company" element={<Company />} />
            <Route path="/downloads" element={<Downloads />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/products" element={<AdminProducts />} />
            <Route path="/admin/carousel" element={<AdminCarousel />} />
            <Route path="/admin/files" element={<AdminFiles />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/company" element={<AdminCompany />} />
          </Routes>
        </Layout>
      </Router>
    </ConfigProvider>
  )
}

export default App
